import React from 'react';

import NotificationsSettingsForm from './NotificationsSettingsForm';
import { useLoadNotificationSettings } from './data';
import { useUpdateNotificationSettings } from './data/mutations';

export const NotificationsSettings = (props) => {
  const { data, isLoading } = useLoadNotificationSettings();
  const [updateNotificationSettings, { isLoading: isUpdating }] =
    useUpdateNotificationSettings();

  const handleSubmit = async (values) => {
    await updateNotificationSettings(values);
    props.onClose();
  };
  return (
    <NotificationsSettingsForm
      loading={isLoading || isUpdating}
      initialValues={data}
      {...props}
      onSubmit={handleSubmit}
    />
  );
};
